<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
// import Loader from "@/components/widgets/preloader";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import Swal from "sweetalert2";
import DataTable from "@/components/DataTable.vue";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Production Orders",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    DataTable,
  },

  data() {
    return {
      CurrentPage: 1,
      serverPerPage: 50,
      filterOrders: {
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        store: "",
        product: "",
        branch_id: 0,
        page: 1,
        per_page: 50,
      },
      deleteData: {
        id: "",
        product: "",
        filterOrders: {},
      },
      editData: {
        id: "",
        product: "",
        quantity: "",
        filterOrders: {},
      },
      quantityError: "",
      modal_id: "",

      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "Production Orders",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Production Orders",
          active: true,
        },
      ],

      pageOptions: [10, 25, 50, 100, 200, 1000],
      IsProductionOrdersServerPaginated: true,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
    };
  },

  computed: {
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("products", ["ProducedProducts"]),
    ...mapGetters("store", ["Stores"]),
    ...mapGetters("recipes", [
      "ProductionOrders",
      "filterStatus",
      "ProductionOrdersPagination",
      "SaveStatus",
      "ProductionOrdersPaginated",
    ]),
    ...mapGetters("products", ["Products"]),
    ...mapGetters("auth", [
      "MyUserPerm",
      "business",
      "branch",
      "Branches",
      "branchid",
    ]),
    ...mapGetters("setting", ["GeneralSettings"]),
    ...mapState("setting", ["general_settings"]),

    fields() {
      let baseFields = [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "product",
          sortable: true,
          label: "PRODUCT",
        },
        {
          key: "quantity",
          sortable: true,
          label: "QUANTITY",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "destination",
          sortable: true,
          label: "PRODUCED TO",
        },
        {
          key: "actions",
          sortable: true,
          label: "ACTIONS",
        },
      ];

      if (this.branchid == 0) {
        baseFields.splice(8, 0, {
          key: "branch",
          sortable: true,
          label: "BRANCH",
        });
      }

      if (
        this.GeneralSettings &&
        this.GeneralSettings.allow_multiple_productcodes
      ) {
        baseFields.splice(2, 0, {
          key: "product_code",
          sortable: true,
          label: "PRODUCT CODE(S)",
        });
      }

      if (this.GeneralSettings && this.GeneralSettings.track_expiries == 1) {
        baseFields.splice(
          5,
          0,
          {
            key: "batch",
            sortable: true,
            label: "BATCH",
          },
          {
            key: "expiry",
            sortable: true,
            label: "EXPIRY",
          },
          {
            key: "manufacture_date",
            sortable: true,
            label: "MANUFACTURED DATE",
          },
        );
      }
      return baseFields;
    },

    rows() {
      return this.IsProductionOrdersServerPaginated
        ? this.ProductionOrdersPagination.total
        : this.ProductionOrdersPaginated
        ? this.ProductionOrdersPaginated.length
        : 0;
    },

    perPage: {
      get() {
        if (this.IsProductionOrdersServerPaginated) {
          return (
            (this.ProductionOrdersPagination &&
              this.ProductionOrdersPagination.per_page) ||
            this.filterOrders.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsProductionOrdersServerPaginated) {
          this.filterOrders.per_page = value;
          this.filterOrders.page = 1;
          this.FetchProductionOrders(this.filterOrders);
        } else {
          this.serverPerPage = value;
        }
      },
    },

    currentPage: {
      get() {
        return this.ProductionOrdersPaginated && this.ProductionOrdersPagination
          ? this.ProductionOrdersPagination.current_page
          : 1;
      },
      set(value) {
        if (this.ProductionOrdersPaginated) {
          this.filterOrders.page = value;
          this.handlePageChange(value);
        }
      },
    },
  },

  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          this.resetEdit();
          this.resetDelete();
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
    general_settings: {
      deep: true,
      handler(newVal) {
        if (newVal.multiple_stores == 1) {
          this.FetchStores();
        }
      },
    },
  },

  methods: {
    ...mapActions({
      FetchItems: "products/fetchProducedProducts",
      FetchStores: "store/fetchStores",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      FetchBranches: "auth/fetchBranches",
      FetchProductionOrders: "recipes/fetchProductionOrders",
      EditOrder: "recipes/editProductionOrder",
      DeleteOrder: "recipes/deleteProductionOrder",
    }),

    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    ProductOrdersFilter() {
      const useServerPagination =
        this.filterOrders.datefrom !== this.filterOrders.dateto;

      let payload = { ...this.filterOrders };

      if (useServerPagination) {
        payload.page = 1;
        payload.per_page = this.serverPerPage;
      }

      this.FetchProductionOrders(payload);
    },

    handlePageChange(newPage) {
      if (this.IsProductionOrdersServerPaginated) {
        this.filterOrders.page = newPage;
        this.FetchProductionOrders(this.filterOrders);
      }
    },

    resetDelete() {
      this.deleteData.product = "";
      this.deleteData.id = "";
    },
    resetEdit() {
      this.editData.id = "";
      this.editData.product = "";
      this.editData.quantity = "";
    },

    showEditModal(row) {
      this.editData.id = row.id;
      this.editData.product = row.product;
      this.editData.quantity = row.quantity;
      this.editData.filterdata = row;
    },
    showDeleteModal(row) {
      this.deleteData.id = row.id;
      this.deleteData.product = row.product;
      this.deleteData.filterdata = row;
    },

    editOrder(modalId) {
      this.modal_id = modalId;
      if (this.editData.quantity == "") {
        this.quantityError = "Quantity field is required";
        return;
      } else {
        this.quantityError = "";
      }
      this.editData.filterOrders = this.filterOrders;
      this.EditOrder(this.editData);
    },
    deleteOrder(modalId) {
      this.modal_id = modalId;
      this.deleteData.filterOrders = this.filterOrders;
      this.DeleteOrder(this.deleteData);
    },
    closeModal(modalId) {
      this.resetError();
      this.resetModal();
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
    resetModal() {
      this.modal_id = "";
    },
    resetError() {
      this.quantityError = "";
    },
  },

  created() {
    this.FetchProductionOrders(this.filterOrders);
    this.FetchItems();
    this.FetchGeneralSettings();
    this.FetchBranches();
  },
};
</script>

<template>
  <Layout>
    <div class="row py-3 text-center">
      <h4 v-if="GeneralSettings.show_businessname == 1" class="text-primary">
        {{ business }}
      </h4>
      <h4 v-if="GeneralSettings.show_branchname == 1 && branch">
        <em
          v-if="
            GeneralSettings.show_branchname == 1 &&
            GeneralSettings.show_businessname == 1
          "
          >-</em
        >
        {{ branch }}
      </h4>
    </div>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-md-9">
                <h3 class="card-title mb-2 text-center">
                  Production Orders from {{ filterOrders.datefrom }} to
                  {{ filterOrders.dateto }}
                </h3>
              </div>
              <div
                class="col-md-3 mb-3"
                v-if="GeneralSettings.multiple_stores == 1"
              >
                <label>FILTER BY STORES</label>
                <model-list-select
                  :list="
                    Stores ? [{ id: 0, name: 'All Stores' }, ...Stores] : []
                  "
                  v-model="filterOrders.store"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Store"
                  @input="ProductOrdersFilter()"
                >
                </model-list-select>
              </div>
            </div>
            <div class="row" v-if="branchid == 0">
              <div class="col-md-8"></div>
              <div class="col-md-4 mb-3">
                <label>FILTER BY BRANCHES</label>

                <model-list-select
                  :list="
                    Branches
                      ? [{ id: 0, name: 'All Branches' }, ...Branches]
                      : []
                  "
                  v-model="filterOrders.branch_id"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Branch"
                  @input="ProductOrdersFilter()"
                >
                </model-list-select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 form-group mb-2">
                <label>FROM</label>
                <input
                  type="date"
                  v-model="filterOrders.datefrom"
                  class="form-control"
                  v-limit-future-date
                />
              </div>
              <div class="col-md-3 form-group">
                <label>TO</label>
                <input
                  v-model="filterOrders.dateto"
                  type="date"
                  class="form-control"
                  v-limit-future-date
                />
              </div>
              <div class="col-md-4 form-group">
                <label>PRODUCT</label>
                <model-list-select
                  :list="
                    ProducedProducts
                      ? [{ id: '', name: 'All Products' }, ...ProducedProducts]
                      : []
                  "
                  v-model="filterOrders.product"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Product"
                  @input="ProductOrdersFilter()"
                >
                </model-list-select>
              </div>
              <div class="col-md-2 mt-4">
                <button
                  class="btn btn-primary"
                  type="button"
                  @click="ProductOrdersFilter()"
                >
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                    v-show="filterStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <!-- Server-side pagination table -->
              <div>
                <DataTable
                  :columns="fields"
                  :rows="ProductionOrders || []"
                  :total-rows="rows"
                  :pagination="ProductionOrdersPagination"
                  :server-pagination="IsProductionOrdersServerPaginated"
                  :loading="SaveStatus"
                >
                  <template #cell(index)="{ index }">
                    {{ (currentPage - 1) * perPage + index + 1 }}
                  </template>
                  <template #cell(product)="{ row }">
                    {{ row.product }}
                  </template>
                  <template
                    #cell(product_code)="{ row }"
                    v-if="GeneralSettings.allow_multiple_productcodes"
                  >
                    {{ row.product_code }}
                  </template>
                  <template #cell(quantity)="{ row }">
                    {{ thousandSeperator(row.quantity) }} {{ row.unitname }}
                  </template>
                  <template #cell(date)="{ row }">
                    {{ row.date }}
                  </template>
                  <template
                    #cell(batch)="{ row }"
                    v-if="GeneralSettings.track_expiries"
                  >
                    {{ row.batch_number }}
                  </template>
                  <template
                    #cell(expiry)="{ row }"
                    v-if="GeneralSettings.track_expiries"
                  >
                    {{ row.expiry_date }}
                  </template>
                  <template
                    #cell(manufacture_date)="{ row }"
                    v-if="GeneralSettings.track_expiries"
                  >
                    {{ row.manufacture_date }}
                  </template>
                  <template #cell(destination)="{ row }">
                    {{ row.destination }}
                  </template>
                  <template #cell(branch)="{ row }" v-if="branchid == 0">
                    {{ row.branch }}
                  </template>

                  <template #cell(actions)="{ row }">
                    <b-button
                      class="btn- btn-sm"
                      variant="primary"
                      v-if="MyUserPerm.savereconcile_shop_stock == 1"
                      v-b-modal.edit-order-modal
                      @click="showEditModal(row)"
                    >
                      <i class="fa fa-edit text-primary"></i>
                      <span class="text-primary"> Edit</span>
                    </b-button>
                    <b-button
                      class="btn- btn-sm"
                      variant="danger"
                      v-if="MyUserPerm.savereconcile_shop_stock == 1"
                      v-b-modal.delete-order-modal
                      @click="showDeleteModal(row)"
                    >
                      <i class="fa fa-trash"></i>
                      <span> Delete</span>
                    </b-button>
                  </template>
                </DataTable>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

            <!-- edit modal starts -->
            <b-modal id="edit-order-modal" hide-footer @hidden="resetModal()">
              <template #modal-title>
                <h4 class="text-warning">
                  Edit Quantity For {{ editData.product }}
                </h4>
              </template>
              <label>Quantity</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="editData.quantity"
                  placeholder="Enter actual quantity"
                  @input="resetError()"
                />
              </div>
              <div class="text-danger" v-if="quantityError">
                <em>{{ quantityError }}</em>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="closeModal('edit-order-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  v-if="SaveStatus"
                  type="button"
                  class="btn btn-warning"
                  disabled
                >
                  <i class="fa fa-minus"></i> Confirm
                  <b-spinner
                    variant="light"
                    small
                    label="Submiting"
                  ></b-spinner>
                </button>
                <button
                  v-else
                  type="button"
                  class="btn btn-warning"
                  @click="editOrder('edit-order-modal')"
                >
                  <i class="fa fa-minus"></i> Confirm
                </button>
              </div>
            </b-modal>
            <!-- edit modal ends -->

            <!-- delete modal ends -->
            <b-modal
              header-bg-variant="danger"
              header-text-variant="light"
              body-text-variant="danger"
              footer-bg-variant="danger"
              footer-text-variant="danger"
              id="delete-order-modal"
              hide-footer
              @hidden="resetDelete"
            >
              <template #modal-title>
                Delete Order for {{ deleteData.product }}</template
              >
              <div class="form-group mb-2">
                <div class="input-group">
                  <h5>
                    Do you want to delete this Order? Click Proceed Button to
                    delete.
                  </h5>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="closeModal('delete-order-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button v-if="SaveStatus" type="button" class="btn btn-danger">
                  <i class="fa fa-trash"></i> Proceed
                  <b-spinner variant="light" small label="Deleting"></b-spinner>
                </button>
                <button
                  v-else
                  type="button"
                  class="btn btn-danger"
                  @click="deleteOrder('delete-order-modal')"
                >
                  <i class="fa fa-trash"></i> Proceed
                </button>
              </div>
            </b-modal>
            <!-- delete modal ends -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>
